import { useSyncExternalStore } from "react";

/**
 * Quais conversas têm o assistente escrevendo AGORA.
 *
 * Vem do aviso em tempo real (`tempo-real.ts`, evento "escrevendo"): o servidor
 * avisa quando o modelo começa a montar a resposta e quando termina. Não é dado
 * do banco — some num recarregar, e é isso mesmo.
 *
 * Teto de 2 minutos por conversa: se o "terminou" se perder (conexão caiu no
 * meio), os pontinhos não ficam na tela para sempre.
 */
const TETO_MS = 120_000;
const ativos = new Map<string, ReturnType<typeof setTimeout>>();
const ouvintes = new Set<() => void>();
let versao = 0;

function mudou() {
  versao++;
  for (const f of ouvintes) f();
}

export function marcarEscrevendo(telefone: string, ativo: boolean) {
  const antes = ativos.get(telefone);
  if (antes) clearTimeout(antes);
  if (ativo) ativos.set(telefone, setTimeout(() => marcarEscrevendo(telefone, false), TETO_MS));
  else ativos.delete(telefone);
  if (Boolean(antes) !== ativo || ativo) mudou();
}

function assinar(f: () => void) {
  ouvintes.add(f);
  return () => {
    ouvintes.delete(f);
  };
}

/** O assistente está escrevendo nesta conversa? */
export function useEscrevendo(telefone: string): boolean {
  useSyncExternalStore(assinar, () => versao, () => versao);
  return ativos.has(telefone);
}
